module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "tabs",
    style: ({
      background: _vm.skinColor
    })
  }, [_c('div', {
    staticClass: "all tab",
    class: {
      isBorder: _vm.tab === 'all'
    },
    on: {
      "click": function($event) {
        _vm.changeTab('all')
      }
    }
  }, [_c('router-link', {
    staticClass: "menu",
    attrs: {
      "to": {
        name: 'ArticleListTab',
        params: {
          tab: 'all'
        }
      }
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _c('div', {
    staticClass: "good tab",
    class: {
      isBorder: _vm.tab === 'good'
    },
    on: {
      "click": function($event) {
        _vm.changeTab('good')
      }
    }
  }, [_c('router-link', {
    staticClass: "menu",
    attrs: {
      "to": {
        name: 'ArticleListTab',
        params: {
          tab: 'good'
        }
      }
    }
  }, [_vm._v("精华")])], 1), _vm._v(" "), _c('div', {
    staticClass: "share tab",
    class: {
      isBorder: _vm.tab === 'share'
    },
    on: {
      "click": function($event) {
        _vm.changeTab('share')
      }
    }
  }, [_c('router-link', {
    staticClass: "menu",
    attrs: {
      "to": {
        name: 'ArticleListTab',
        params: {
          tab: 'share'
        }
      }
    }
  }, [_vm._v("分享")])], 1), _vm._v(" "), _c('div', {
    staticClass: "ask tab",
    class: {
      isBorder: _vm.tab === 'ask'
    },
    on: {
      "click": function($event) {
        _vm.changeTab('ask')
      }
    }
  }, [_c('router-link', {
    staticClass: "menu",
    attrs: {
      "to": {
        name: 'ArticleListTab',
        params: {
          tab: 'ask'
        }
      }
    }
  }, [_vm._v("问答")])], 1), _vm._v(" "), _c('div', {
    staticClass: "job tab",
    class: {
      isBorder: _vm.tab === 'job'
    },
    on: {
      "click": function($event) {
        _vm.changeTab('job')
      }
    }
  }, [_c('router-link', {
    staticClass: "menu",
    attrs: {
      "to": {
        name: 'ArticleListTab',
        params: {
          tab: 'job'
        }
      }
    }
  }, [_vm._v("招聘")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dev tab",
    class: {
      isBorder: _vm.tab === 'dev'
    },
    on: {
      "click": function($event) {
        _vm.changeTab('dev')
      }
    }
  }, [_c('router-link', {
    staticClass: "menu",
    attrs: {
      "to": {
        name: 'ArticleListTab',
        params: {
          tab: 'dev'
        }
      }
    }
  }, [_vm._v("客户端测试")])], 1)]), _vm._v(" "), _c('div', {
    ref: "articles",
    staticClass: "article",
    on: {
      "scroll": function($event) {
        _vm.scroll($event)
      }
    }
  }, [_c('ArticleLoading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "loading"
  }), _vm._v(" "), _c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-192af374"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/Content.vue
// module id = 328
// module chunks = 4